import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import UserSelect from '../../../../../containers/users/select/UserSelect'
import SegwareTechnicianSelect from '../../../../../containers/integrations/Segware/SegwareTechnicianSelect'

const GeneralSection = () => {
  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%">
        <FormItem label="Usuário local" Input={UserSelect} field="user" />
      </Col>
      <Col width="100%" wrapOn="sm">
        <FormItem label="Técnico na Segware" Input={SegwareTechnicianSelect} field="technician" />
      </Col>
    </Grid>
  )
}

export default GeneralSection
